<template>
  <div style="overflow-y: auto; height: 100%">
    <VueQueryBuilder
      :customItems="customItems"
      @change="handleChange"
      ref="queryBuilder"
      :slots="slots"
      :labels="labels"
      :maxDepth="3"
      v-model="query"
      :rules="rules"
    >
    </VueQueryBuilder>
  </div>
</template>

<script>
import VueQueryBuilder from "../compones/VueQueryBuilder.vue";
export default {
  components: {
    VueQueryBuilder,
  },

  props: {
    customItems: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: "100%",
    },
    slots: {
      type: Object,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },

  name: "l-complex-query",
  mounted() {},
  data() {
    return {
      dialogVisible: true,
      query: { logicalOperator: "AND", children: [] },
      lastChange: null,
      defaultQuery0: { logicalOperator: "AND", children: [] },
      defaultQuery1: { logicalOperator: "OR", children: [] },
      labels: {
        matchType: "匹配类型",
        matchTypes: [
          { id: "all", label: "所有" },
          { id: "any", label: "任何" },
        ],
        addRule: "添加规则",
        removeRule: "&times;",
        addGroup: "添加组",
        removeGroup: "&times;",
        textInputPlaceholder: "value",
      },
    };
  },
  computed: {},
  methods: {
    handleChange(val) {
      this.$emit("queryChange", this.countGroupsAndRules(val));
    },
    countGroupsAndRules(json) {
      let groups = 0;
      let rules = 0;

      if (json.children) {
        for (let child of json.children) {
          if (child.type === "query-builder-rule") {
            rules++;
          } else if (child.type === "query-builder-group") {
            groups++;
            const { groups: nestedGroups, rules: nestedRules } =
              this.countGroupsAndRules(child.query);
            groups += nestedGroups;
            rules += nestedRules;
          }
        }
      }

      return { groups, rules };
    },
    closeComplexQuery() {
      this.$emit("close");
      // if (!this.checkForValue(this.query)) {
      //   this.$message({
      //     message: "未填写完整,无法应用到查询中。",
      //     type: "warning",
      //   });
      //   return;
      // }
    },
    clearComplexQuery() {
      this.$refs.queryBuilder.clear();
      this.$emit("clearExpression");
    },
    saveComplexQuery() {
      let _this = this;
      let queryJsonStr = JSON.stringify(this.query);

      if (!this.checkForValue(_this.query)) {
        return;
      }

      if (
        JSON.stringify(this.defaultQuery0) === queryJsonStr ||
        JSON.stringify(this.defaultQuery1) === queryJsonStr
      )
        this.$emit("saveExpression", null);

      this.$emit("saveExpression", queryJsonStr);
      // this.$message({
      //   message: "已应用到查询中",
      //   type: "success",
      // });
    },

    handleQuery() {
      let hasNull = !this.checkForValue(this.query);
      // this.convertTimestampsInJson(this.query);
      let queryJsonStr = JSON.stringify(this.query);
      if (
        JSON.stringify(this.defaultQuery0) === queryJsonStr ||
        JSON.stringify(this.defaultQuery1) === queryJsonStr
      ) {
        this.$emit("complexQuery", null);
        return;
      }

      if (hasNull) {
        this.$message({
          message: "请补全空值",
          type: "warning",
          offset: 45,
        });
        return;
      }

      // this.dialogVisible = false;
      this.$emit("complexQuery", queryJsonStr);
    },

    convertTimestampsInJson(jsonData) {
      if (jsonData && jsonData.children && Array.isArray(jsonData.children)) {
        jsonData.children.forEach((child) => {
          if (
            child.query.type === "date" ||
            (child.query.type === "datetime" &&
              child.query.selectedOperator != ";")
          ) {
            // 确保value是数字且为有效的timestamp
            if (typeof child.query.value === "number") {
              child.query.value = this.convertTimestampToSqlDateTime(
                child.query.value
              );
            }
          } else if (
            child.query.type === "date" ||
            child.query.type === "datetime"
          ) {
            if (Array.isArray(child.query.value)) {
              child.query.value[0] = this.convertTimestampToSqlDateTime(
                child.query.value[0]
              );
              child.query.value[1] = this.convertTimestampToSqlDateTime(
                child.query.value[1]
              );
            }
          }
          // 递归检查子节点
          if (child.query && child.query.children) {
            this.convertTimestampsInJson(child.query);
          }
        });
      }
    },
    checkForValue(obj) {
      // 遍历对象的所有属性
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          // 新增逻辑：检查同级:selectedOperator的值是否为"isNULL"或"isnotnull"
          if (
            key === "selectedOperator" &&
            (obj[key] === "IS NOT NULL" || obj[key] === "IS NULL")
          ) {
            // 如果是，则在该层级允许value为空，直接跳过value的检查
            continue;
          }

          // 当前属性是value且其值为空，且同级:selectedOperator不是"isNULL"或"isnotnull"时，返回false
          if (
            key === "value" &&
            (obj[key] === undefined || obj[key] === "" || obj[key] === null) &&
            (!obj["selectedOperator"] ||
              (obj["selectedOperator"] !== "IS NULL" &&
                obj["selectedOperator"] !== "IS NOT NULL"))
          ) {
            return false;
          }

          // 如果当前属性是对象或数组，则递归检查
          else if (typeof obj[key] === "object" && obj[key] !== null) {
            if (!this.checkForValue(obj[key])) {
              return false; // 一旦发现需视为空的value且不符合特殊条件，立即返回
            }
          }
        }
      }

      // 如果循环结束没有提前返回，说明没有找到需视为空的value
      return true;
    },
    convertTimestampToSqlDateTime(timestamp) {
      if (typeof timestamp === "number") {
        // 创建Date对象，注意timestamp是以毫秒为单位
        const date = new Date(timestamp);
        // 格式化日期时间字符串，确保包含毫秒部分
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的，所以需要+1
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        const milliseconds = String(date.getMilliseconds()).padStart(3, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
      }
      return null; // 或者抛出错误，处理非数字输入的情况
    },

    // 处理单个规则
    queryToSql(query) {
      var sql = [];
      var that = this;
      var logicalOperator = query.logicalOperator;
      var children = query.children;
      children.forEach((child) => {
        var type = child.type;
        if (type === "query-builder-rule") {
          sql.push(child.query.rule);
          sql.push(
            this.operatorDisposer(
              child.query.selectedOperator,
              child.query.value
            )
          );
          if (!this.isSpecialOperator(child.query.selectedOperator)) {
            sql.push(this.valueDisposer(child.query));
          } else {
          }
        } else {
          sql.push("(");
          sql.push(that.queryToSql(child.query));
          sql.push(")");
        }
        sql.push(logicalOperator);
      });
      sql.splice(sql.length - 1, sql.length);
      return sql.join(" ");
    },

    isSpecialOperator(operator) {
      return (
        operator === "IS NULL" ||
        operator === "IS NOT NULL" ||
        operator === "IN" ||
        operator === "NOTIN" ||
        operator === "LIKE '%...%'"
      );
    },
    operatorDisposer(operator, value) {
      switch (operator) {
        case "IS NULL":
          return "IS NULL";
        case "IS NOT NULL":
          return "IS NOT NULL";
        case "IN":
          return "IN";
        case "NOTIN":
          return "NOTIN";
        case "LIKE '%...%'":
          return operator.replace("...", value);
        default:
          return operator;
      }
    },
    valueDisposer(query) {
      switch (query.type) {
        case "text":
          return "'" + query.value + "'";
        case "numeric":
          return query.value;
        case "date":
          return "'" + query.value + "'";
        case "datetime":
          return "'" + query.value + "'";

        default:
          return query.value;
      }
    },
  },
};
</script>
